initAddAdditionalPlan();

function initAddAdditionalPlan() {
    const select = (element) => document.querySelector(element);
    const selectAll = (element) => document.querySelectorAll(element);

    const planos = selectAll('.card-plan-b2c.has_itens_add');
    const idPlans = Array.from(planos)?.map(card => card.getAttribute('data-plan-id'));

    idPlans?.forEach(idPlan => {
        var valuePlan = +select(`.card-plan-b2c[data-plan-id="${idPlan}"]`).getAttribute('data-plan-price');
        const itensAdd = selectAll(`.card-plan-b2c[data-plan-id="${idPlan}"] .item-add`);
        const tagValueCard = select(`.card-plan-b2c[data-plan-id="${idPlan}"] .value-br > p`);
        const dataValueDataBtnShowCart = select(`.card-plan-b2c[data-plan-id="${idPlan}"] .addProduct`)
        const tagValueCart = selectAll('#plan_price');
        let updatedValue = valuePlan;

        itensAdd.forEach(item => item.addEventListener('click', (e)=> {
            let valueItem = toggleCheckAndSetValue(e, item);
            updatedValue = updatedValue + valueItem;
            tagValueCard.innerText = `R$${updatedValue.toFixed(2).replace('.', ',')}`;
            dataValueDataBtnShowCart.setAttribute('data-plan-price', updatedValue.toFixed(2))
            tagValueCart.forEach(tag => tag.innerText = `R$ ${updatedValue.toFixed(2).replace('.', ',')}/mês`);

            const inputHiddenMesh = document.getElementById(`input-mesh-${idPlan}`);

            const inputHiddenChip = document.getElementById(`input-chip-${idPlan}`);

            if(valueItem == 20){
                inputHiddenMesh.value = true;
            } else if (valueItem == -20){
                inputHiddenMesh.value = false;
            }

            if (valueItem == 40){
                inputHiddenChip.value = true;
            } else if (valueItem == -40){
                inputHiddenChip.value = false;
            }

        }))

    });


    function toggleCheckAndSetValue(e, item) {
        e.preventDefault();

        valueItemAdd = +item.getAttribute('data-value');

        item.classList.toggle('active');

        return (item.classList.contains('active'))
                ? valueItemAdd
                : - valueItemAdd
    }
}
